"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppThemeProvider = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const lightBlue_1 = __importDefault(require("@material-ui/core/colors/lightBlue"));
const deepOrange_1 = __importDefault(require("@material-ui/core/colors/deepOrange"));
const styles_1 = require("@material-ui/core/styles");
const createMuiTheme_1 = require("./createMuiTheme");
const AppThemeProvider = props => {
    const { theme: themeOptions, children } = props;
    const theme = (0, createMuiTheme_1.createTheme)(Object.assign({ palette: {
            primary: {
                main: '#2196f3',
                light: lightBlue_1.default[50]
            },
            secondary: {
                light: '#f1f3f3',
                main: '#fff'
            },
            error: {
                main: deepOrange_1.default['A400']
            }
        }, typography: {
            overline: {
                letterSpacing: 1,
                fontWeight: 500
            }
        }, breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 768,
                lg: 960,
                xl: 1024
            }
        }, overrides: {
            MuiInputBase: {
                input: {
                    fontSize: 14
                }
            },
            MuiInputLabel: {
                outlined: {
                    transform: 'translate(14px, 18px) scale(1)'
                }
            },
            MuiOutlinedInput: {
                input: {
                    padding: '16px 14px'
                }
            },
            MuiFormControlLabel: {
                label: {
                    fontSize: 13
                }
            },
            MuiTableContainer: {
                root: {
                    overflow: 'auto'
                }
            },
            MuiTable: {
                root: {
                    whiteSpace: 'nowrap'
                }
            },
            MuiTableRow: {
                hover: {
                    cursor: 'pointer'
                },
                root: {
                    '&$selected, &$selected:hover': { backgroundColor: lightBlue_1.default[50] },
                    '&.deleted': {
                        backgroundColor: (0, styles_1.alpha)(deepOrange_1.default['A400'], 0.1)
                    }
                }
            },
            MuiDialog: {
                paper: {
                    width: '80%'
                }
            },
            MuiDialogActions: {
                root: {
                    padding: '8px 24px'
                }
            }
        } }, themeOptions));
    return (
    //Make sure the Material stylesheet is placed above your own
    //styles so you can overwrite them
    react_1.default.createElement(styles_1.StylesProvider, null,
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: theme },
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme }, children))));
};
exports.AppThemeProvider = AppThemeProvider;
exports.default = exports.AppThemeProvider;
//# sourceMappingURL=AppThemeProvider.js.map